import { Trans, useTranslation } from "gatsby-plugin-react-i18next";

const Integrations = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 int-1">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                        <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                            <Trans>
                                Synchronize the <br/>
                                Health Ecosystem!
                            </Trans>
                        </h1>
                        <p className="hero-para font-weight-semibold no-br">
                            <Trans>
                                Simplify integration with devices, apps <br/>
                                and HR systems for a unified wellness
                                experience.
                            </Trans>
                        </p>
                        <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                            <a
                                href={t(`/request-demo/`)}
                                className="vfitcompanycta arrowbtn-img"
                            >
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative pl-0 pr-0">
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                        <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label red-font no-br">
                                        <Trans>Apps & Devices</Trans>
                                    </div>
                                    <h2 className="font-weight-semibold py-2 section-heading">
                                        <Trans>Connect What You Prefer</Trans>
                                    </h2>
                                    <p className="section-para font-weight-normal">
                                        <Trans>
                                            Whether it's an app, wearable, or
                                            any device, unlock effortless
                                            integration for your employees. Let
                                            them effortlessly monitor their
                                            health journey with Vantage Fit.
                                        </Trans>
                                    </p>
                                    <div className="col-12 d-flex justify-content-center align-items-center pt-2 flex-wrap flex-m-nowrap px-0">
                                        <div className="row justify-content-center justify-content-md-start">
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500599/VantageFit/2023/wearables2/Bitmap.webp"
                                                    alt="Apple Watch"
                                                    width="96"
                                                    height="21"
                                                />
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500598/VantageFit/2023/wearables2/Bitmap_3.webp"
                                                    alt="Fitbit"
                                                    width="95"
                                                    height="30"
                                                />
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500598/VantageFit/2023/wearables2/Bitmap_2.webp"
                                                    alt="Garmin"
                                                    width="102"
                                                    height="35"
                                                />
                                            </div>
                                            {/* <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500598/VantageFit/2023/wearables2/Bitmap_4.webp"
                                                    alt="Sony"
                                                    width="89"
                                                    height="16"
                                                />
                                            </div> */}
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500599/VantageFit/2023/wearables2/Bitmap_5.webp"
                                                    alt="Google Fit"
                                                    width="114"
                                                    height="23"
                                                />
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center int-logos mb-3">
                                                <img
                                                    decoding="async"
                                                    loading="lazy"
                                                    className="img-responsive"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1717500599/VantageFit/2023/wearables2/Group_24.webp"
                                                    alt="Apple Health"
                                                    width="127"
                                                    height="19"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 cta-img">
                                <div className="d-flex justify-content-center">
                                    <img
                                        className="img-responsive"
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1701166425/VantageFit/2023/Vfit-Integration-Apps_Devices.webp"
                                        loading="lazy"
                                        alt="Connect What You Prefer"
                                        width="500"
                                        height="617"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                        <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label orange-font">
                                        <Trans>Slack Integration</Trans>
                                    </div>
                                    <h2 className="font-weight-semibold py-2 section-heading">
                                        <Trans>
                                            Streamlining Chat and Collaboration
                                        </Trans>
                                    </h2>
                                    <p className="section-para font-weight-normal">
                                        <Trans>
                                            Enjoy effortless integration with
                                            your existing Slack culture,
                                            ensuring seamless communication and
                                            collaboration. <br />
                                            <br />
                                            Stay informed about your colleagues'
                                            leaderboard scores, track your
                                            progress in ongoing campaigns by
                                            monitoring steps taken and calories
                                            burned, and keep tabs on your
                                            overall Vantage Fit points earned.
                                        </Trans>
                                    </p>
                                    <div className="flw100">
                                        <a
                                            href={t(`/slack-integration/`)}
                                            className="links int-link"
                                        >
                                            <Trans>Learn More</Trans>
                                            {/* <span className="campaignSprite"></span> */}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 cta-img">
                                <div className="col-12 d-flex justify-content-center">
                                    <img
                                        className="img-responsive"
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1708943407/VantageFit/2023/Streamlining_Chat_and_Collaboration-integration.webp"
                                        loading="lazy"
                                        alt="Streamlining Chat and Collaboration"
                                        width="500"
                                        height="447"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                        <div className="container custom_container d-md-flex justify-content-center align-items-center">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label green-font">
                                        <Trans>HRMS Capabilities</Trans>
                                    </div>
                                    <h2 className="font-weight-semibold py-2 section-heading">
                                        <Trans>Harmonize Wellness & Work</Trans>
                                    </h2>
                                    <p className="section-para font-weight-normal">
                                        <Trans>
                                            Link your HR systems, streamlining
                                            wellness initiatives for all
                                            employees.
                                        </Trans>
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 cta-img">
                                <div className="col-12 d-flex justify-content-center">
                                    <img
                                        className="img-responsive"
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1701166428/VantageFit/2023/Vfit-Integration-HRMS.webp"
                                        loading="lazy"
                                        alt="Harmonize Wellness & Work"
                                        width="500"
                                        height="537"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative pl-0 pr-0">
                <div className="section-heading-top cursive">
                    <h2 className="section-heading font-weight-bold text-center mb-4">
                        <Trans i18nKey="subtextfeat10">
                            Your&nbsp;
                            <span className="charmonman green-clr">
                                Holistic
                            </span>
                            &nbsp;Wellness Amplifier
                        </Trans>
                        &nbsp;!
                    </h2>
                    <div className="section-para text-center">
                        <Trans>
                            Facilitate seamless integration with devices, apps,
                            and HR systems to enhance wellness tracking.
                        </Trans>
                    </div>
                </div>
            </section>

            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="font-weight-semibold section-heading text-center no-br">
                            <Trans>
                                Are you Ready to Integrate and Elevate?
                            </Trans>
                        </h2>
                        <p className="sub-para font-weight-normal text-center mb-5 text-white">
                            <Trans>
                                Unify the health ecosystem of your employees
                                with Vantage Fit and witness unmatched synergy
                                in their wellness journey.
                            </Trans>
                        </p>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a
                                href={t(`/request-demo/`)}
                                className="vfitcompanycta arrowbtn-img"
                            >
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Integrations;
